export const LAST_SELECTED_CLIENT_GROUP_KEY = "last-selected-client-group";
